/* 
* <license header>
*/

/* global fetch */

import { getExperienceParams } from "./experienceContext";

/**
 *
 * Invokes a web action
 *
 * @param  {string} actionUrl
 * @param {object} headers
 * @param  {object} params
 *
 * @returns {Promise<string|object>} the response
 *
 */

async function actionWebInvoke (actionUrl, headers = {}, params = {}, options = { method: 'POST' }) {
  const actionHeaders = {
    'Content-Type': 'application/json',
    ...headers
  }

  const fetchConfig = {
    headers: actionHeaders
  }

  if (window.location.hostname === 'localhost') {
    actionHeaders['x-ow-extra-logging'] = 'on'
  }

  fetchConfig.method = options.method.toUpperCase()

  const mergedParams = {
    ...getExperienceParams(),
    ...params
  }

  if (fetchConfig.method === 'GET') {
    actionUrl = new URL(actionUrl)
    Object.keys(mergedParams).forEach(key => actionUrl.searchParams.append(key, mergedParams[key]))
  } else if (fetchConfig.method === 'POST') {
    fetchConfig.body = JSON.stringify(mergedParams)
  }

  const response = await fetch(actionUrl, fetchConfig)

  let content = await response.text()

  if (!response.ok) {
    throw new Error(`failed request to '${actionUrl}' with status: ${response.status} and message: ${content}`)
  }
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }
  return content
}

export default actionWebInvoke
